<template>
  <div>
    <md-field :class="validationClass">
      <label for="email">Email</label>
      <md-input type="email" autofocus="true" name="email" id="email" autocomplete="email" v-model="form.email" :disabled="sending" />
      <span class="md-error" v-if="!$v.form.email.required">The email is required</span>
      <span class="md-error" v-else-if="!$v.form.email.email">Invalid email</span>
    </md-field>
    <md-progress-bar md-mode="indeterminate" v-if="sending" />
    <md-card-actions>
      <md-button type="submit" class="md-primary" :disabled="sending" @click="validateAndSend">Send</md-button>
    </md-card-actions>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import { validationMixin } from 'vuelidate'
import {
  required,
  email
} from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin],
  data() {
    return {
      form: {
        email: null
      }
    }
  },

  validations: {
    form: {
      email: {
        required,
        email
      }
    }
  },

  computed: {
    ...mapState([
      'sending',
      'notification',
      'showNotification',
      'email'
    ]),
    validationClass() {
      var field = this.$v.form.email
      return { 'md-invalid': field.$invalid && field.$dirty }
    }
    
  },

  methods: {

    ...mapActions(['sendForgotPasswordRequest']),
    
    async validateAndSend() {
      this.$v.$touch()

      if (!this.$v.$invalid) {
	await this.sendForgotPasswordRequest(this.form.email)
      }
      
    }
  }
}

</script>
